import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "40",
  height: "40",
  fill: "none",
  viewBox: "-5 -2.5 32 32"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#1783FF",
      d: "M21.72.94c1.23 0 2.23 1 2.23 2.23s-1 2.23-2.23 2.23h-1.97c-.15 0-.26-.12-.26-.26V3.17c0-1.23 1-2.23 2.23-2.23"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m9.39 13.95 8.43-8.36c.16-.16.07-.47-.14-.47h-4.54s-.1.02-.14.06l-9.08 9.01c-.14.14-.35.02-.35-.21V5.39c0-.15-.1-.27-.22-.27H.22c-.12 0-.22.12-.22.27v18.53c0 .15.1.27.22.27h3.13c.12 0 .22-.12.22-.27v-3.78c0-.08.03-.16.08-.21l2.82-2.79c.07-.07.16-.08.24-.03l7.53 5.54c1.23.83 2.61 1.34 4.01 1.49.12.01.23-.11.23-.27v-3.56c0-.14-.08-.25-.19-.26-.82-.13-1.63-.45-2.35-.94l-6.52-4.72c-.14-.09-.15-.32-.03-.44"
    }, null, -1)
  ]))]))
}
export default { render: render }